define('core/collections/MediaCollection',[
    'backbone',

    'core/models/Media',
], function (
    Backbone,

    Media
) {
    'use strict';

    var MediaCollection = Backbone.Collection.extend({
        model: Media,
    });

    return MediaCollection;
});

